import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Appbar, Sidebar } from '../components/v2';
import './style.css';
import { ColorsV2 } from 'app/constants/color';

const Layout = () => {
  useEffect(() => {
    document.documentElement.style.setProperty('--body-bg-color', ColorsV2.primary);
  }, []);

  return (
    <div>
      <main className='dashboard' style={{ background: ColorsV2.primary }}>
        <Sidebar />
        <div
          style={{
            overflow: 'hidden',
            background: ColorsV2.primary,
          }}
        >
          <Appbar />
          <div
            className='dashboard-page'
            style={{
              backgroundColor: ColorsV2.primary,
              height: '100%',
            }}
          >
            <Outlet />
          </div>
        </div>
      </main>
    </div>
  );
};
export default Layout;
